import { create } from 'zustand';

export interface PathStore {
  path: string;
  setPath(path: string): void;
}

export const usePathStore = create<PathStore>()((set) => ({
  path: '',
  setPath: (path: string) => {
    set((prev) => {
      return {
        ...prev,
        path,
      };
    });
  },
}));
